// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"104":"24f63f0e8658048b","257":"d34edf6bec4e9f2c"}[chunkId] + ".js";
};